module.exports = __webpack_public_path__ + "static/media/VectorPointConcluido14.e40ea58f.svg";